import { render, staticRenderFns } from "./DocumentContentModal.vue?vue&type=template&id=0c274a67&scoped=true&"
import script from "./DocumentContentModal.vue?vue&type=script&lang=js&"
export * from "./DocumentContentModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentContentModal.vue?vue&type=style&index=0&id=0c274a67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c274a67",
  null
  
)

export default component.exports